import '../../node_modules/ng2-material-components/ng2-material-components.bundle.css';
import '../style/app.scss';

import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart } from '@angular/router';

import { MenuItem } from 'ng2-material-components/ng2-material-components';
import { IAppEvent } from './shared/models';
import { Store, State, AuthService, UserService, AppStateService } from './shared/services';
import { IUserInfo } from './shared/models';


@Component({
  selector: 'my-app',
  template: require('./app.component.pug'),
  styles: [require('./app.component.scss')],
})
export class AppComponent implements OnInit {
  loading = false;
  name = 'Nova On The Go';
  url = 'http://www.novapointofsale.com';

  headerTitle: string = 'Nova Mobile App';
  headerActions: MenuItem[] = null;
  showHeader: boolean;
  opacity: number;
  sidebarOpen: boolean;
  backActive: boolean;

  private _hasToShowHeader: boolean = true;

  constructor(
    private _store: Store,
    private _authService: AuthService,
    private _router: Router,
    private _userSvc: UserService,
    private _appStateService: AppStateService) {
    // Do something with api
  }

  ngOnInit() {
    this._store.changes$.subscribe(state => this._processStoreChanges(state));
    this._userSvc.user$.subscribe(user => this._processUserChanges(user));
    // TODO: migrate this to the store, not need to be separated
    this._subscribeToTitleChanges();
    this._subscribeHasToShowHeaderChanges();

    this._appStateService.backAction$.subscribe((value: boolean) => {
        this.backActive = value;
    });

    // close side bar everytime we are openning a new route
    this._router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.sidebarOpen = false;
        this.backActive = false;
      }
    })
  }

  onActionClicked(item: MenuItem) {
    this._store.pushAppEvent({
      type: 'action',
      data: item,
    });
  }

  onBackActionClicked() {
    this._store.pushAppEvent({
      type: 'backAction',
    });
  }

  onMenuItemClicked(item: MenuItem) {
    // if (!item.children) {
    //   this.sidebarOpen = false;
    // }
  }

  private _processStoreChanges(state: State) {
    // header actions
    if (state.headerActions !== null && state.headerActions.length !== 0) {
      this.headerActions = state.headerActions;
    }
  }

  private _processUserChanges(user: IUserInfo) {
    // user changes
    if (user !== null && this._hasToShowHeader) {
      this.showHeader = true;
      this.opacity = 0.8;
    } else {
      this._hideHeader();
    }

  }

  private _subscribeToTitleChanges() {
    let that = this;

    this._store.appEvents$.subscribe((appEvent: IAppEvent) => {
      if (appEvent.type === 'title') {
        that.headerTitle = appEvent.data;
      }
    });
  }

  private _subscribeHasToShowHeaderChanges() {
    let that = this;

    this._store.appEvents$.subscribe((appEvent: IAppEvent) => {
      if (appEvent.type === 'hideHeader') {
        that._hasToShowHeader = appEvent.data;
        if (!that._hasToShowHeader) {
           that._hideHeader();
        }
      }
    });
  }

  private _hideHeader() {
      this.sidebarOpen = false;
      this.showHeader = false;
      this.opacity = 0.4;
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/app.component.ts